import referer from './referer';
import tools from './tools';
import video from './video';
import guides from './guides';
import models from './models';
import generator from './generator';
import text from './text';
import derivative from './derivative';
import colorAdjustment from './color-adjustment';
import selectionTools from './selection-tools';
import inpaint from './inpaint';
import outpaint from './outpaint';
import upscale from './upscale';
import shape from './shape';
import crop from './crop';
// import lines from './lines';
import smartRemove from './smartRemove';
import removeBackground from './removeBackground';
import workflow from './workflow';
import selectAreaTool from './selectAreaTool';

export default {
  tools,
  video,
  models,
  referer,
  workflow,
  guides,
  generator,
  derivative,
  text,
  shape,
  // lines,
  crop,
  smartRemove,
  removeBackground,
  selectionTools,
  colorAdjustment,
  inpaint,
  upscale,
  outpaint,
  selectAreaTool,
};
